import { Theme } from "@mui/material";

export const useStyles = (theme: Theme) => ({
  boxBar: {
    position: "fixed",
    bottom: 15,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.drawer,
    pointerEvents: "none",
  },
  paperBar: {
    pointerEvents: "auto",
    borderRadius: "5px",
    padding: 1,
    width: { xs: "95%", md: "fit-content" },
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "start", md: "center" },
    gap: 2,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 8px 30px rgba(0,0,0,0.3)",
  },
  badgeCount: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.75rem",
    fontWeight: "bold",
  },
});
